export default "__VITE_ASSET__866cc320__"